<template>

  <div class="modal-mask" v-show="showRejectModal" transition="modal">
    <div class="modal-wrapper">
      <div class="modal-container">
        <div class="modal-header">
          <slot name="header">Категория</slot>
        </div>

        <div class="modal-body">
          <div class="form-group">
            <label>Причина отказа [RU]</label>
            <input type="text" class="form-control" v-model="reject_data"/>
          </div>
        </div>
        <div class="modal-footer">
          <slot name="footer">
            <button class="modal-button btn btn-danger" @click="updateTab('update',{modal:'cancel',visible: false})">Закрыть</button>

            <a
                href="javascript:void(0);"
                @click="cancelAction(action.id)"
                class="btn btn-warning ml-1">Отменить</a>
          </slot>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {POST} from "@/shared/api";

export default {
  props: {
    action: {},
    showRejectModal: false,
  },
  data() {
    return {
      reject_data: "",
    }
  },
  methods: {
    updateTab(event, state) {
      this.$emit(event, state);
    },
    cancelAction(validateAction_id) {
      POST({mode: 0, id: validateAction_id, comment: this.reject_data}, "/validate-actions/action", this, true).then((response) => {
        this.updateTab('update',{modal:'cancel',visible: false, getAA:true})
      })
    },
  },
  mounted() {
    // console.log(this.action);
  }
}
</script>

<style scoped>

</style>